import { LoadingButton } from '@mui/lab'
import { LoadingButtonProps } from '@mui/lab/LoadingButton/LoadingButton'
import { Button, ButtonProps, styled } from '@mui/material'

export const RoundButton = styled(Button)<ButtonProps>(() => ({
  borderRadius: '24px',
  textTransform: 'none',
  minWidth: 'auto',
  boxShadow: 'none',
  '&:hover': { boxShadow: 'none' },
  '&:active': { boxShadow: 'none' },
}))

export const RoundLoadingButton = styled(LoadingButton)<LoadingButtonProps>(
  () => ({
    borderRadius: '24px',
    textTransform: 'none',
    minWidth: 'auto',
    boxShadow: 'none',
    '&:hover': { boxShadow: 'none' },
    '&:active': { boxShadow: 'none' },
  })
)
